import { render, staticRenderFns } from "./clbj.vue?vue&type=template&id=c58b4b44&scoped=true&"
import script from "./clbj.vue?vue&type=script&lang=js&"
export * from "./clbj.vue?vue&type=script&lang=js&"
import style0 from "./clbj.vue?vue&type=style&index=0&id=c58b4b44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58b4b44",
  null
  
)

export default component.exports